import { render, staticRenderFns } from "./CongestionSummary.vue?vue&type=template&id=b62a5876&scoped=true&"
import script from "./CongestionSummary.vue?vue&type=script&lang=js&"
export * from "./CongestionSummary.vue?vue&type=script&lang=js&"
import style0 from "./CongestionSummary.vue?vue&type=style&index=0&id=b62a5876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62a5876",
  null
  
)

export default component.exports